import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import {
  converDateIntoLocal1,
  classNames,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import Button from "react-bootstrap-button-loader";
import ReportIssueModal from "./reportissuemodal";
import moment from "moment";
import {
  fetchadminissueTokenClose,
  updateissueStatus,
  fetchadminissueTokenOpen,
} from "AccountSettingsAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "../../../../../languages";
import renderHTML from "react-render-html";

class ReportIssueitemList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetpassword: false,
      loading: false,
      allowingaccess: false,
      selectedUsers: [],
      showEmailPreviewModal: false,
      btnloading: false,
    };
  }

  openModal = () => {
    this.setState({
      isOpen: true,
    });
  };
  closeModal = () => {
    this.setState({ isOpen: false });
  };

  handleresolveandreopen = (values) => {
    let { user } = this.props;
    let groupNumber = user.groupNumber;
    let clientid = user.clientid;
    this.setState({ btnloading: true });
    let obj = {
      id: values.id,
    };
    if (values.status == "open") {
      obj.status = "closed";
    } else {
      obj.status = "open";
    }
    this.props.updateissueStatus(this.props.session, obj, (response) => {
      if (response.success === 0) {
        this.setState({ btnloading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.fetchadminissueTokenOpen(
          this.props.session,
          clientid,
          (CallBackResponse) => {
            this.props.fetchadminissueTokenClose(
              this.props.session,
              clientid,
              (CallBackResponse) => {
                this.setState({ btnloading: false });
                this.props.showSuccess("Successfully Updated");
              }
            );
          }
        );
      }
    });
  };

  render() {
    let { values, index } = this.props;
    let tabledate = "";
    let letLastobj = "";
    let lastrepliedon = "";
    let lastreplieddesc = "";
    if (
      values.support_ticket_messages_by_reportissueidfk &&
      values.support_ticket_messages_by_reportissueidfk.length > 0
    ) {
      tabledate = tabledate = converDateIntoLocal1(values.createdon).format(
        "D MMM YYYY HH:mm A"
      );
      if (
        values.support_ticket_messages_by_reportissueidfk &&
        values.support_ticket_messages_by_reportissueidfk.length > 0
      ) {
        let filteredlist = _.filter(
          values.support_ticket_messages_by_reportissueidfk,
          (obj, index) => {
            return obj.isdraft == false || obj.isdraft == 0;
          }
        );
        // console.log("filteredlist", filteredlist);
        letLastobj = _.last(filteredlist);
      }
      // letLastobj = _.last(values.support_ticket_messages_by_reportissueidfk);
      lastrepliedon = converDateIntoLocal1(letLastobj.createdon).format(
        "D MMM YYYY HH:mm A"
      );

      if (
        letLastobj.description != "" &&
        letLastobj.description != null &&
        letLastobj.description.length >= 90
      ) {
        lastreplieddesc = letLastobj.description.substring(0, 90) + "...";
      } else if (
        letLastobj.description != "" &&
        letLastobj.description != null
      ) {
        lastreplieddesc = letLastobj.description;
      }
    }
    let draft = [];
    draft = _.filter(
      values.support_ticket_messages_by_reportissueidfk,
      (obj, index) => {
        return obj.isdraft == true && obj.repliedby !== null;
      }
    );

    return (
      <>
        <tr className="cursor-pointer" onClick={() => this.openModal()}>
          <td className="td1">
            <div className="">Ticket#{values.tokenno}</div>
          </td>

          <td className="td4">
            <div className="custom-text1-primary-medium">
              {values.support_ticket_messages_by_reportissueidfk &&
              values.support_ticket_messages_by_reportissueidfk.length > 0
                ? values.support_ticket_messages_by_reportissueidfk[0].subject
                : "-"}
            </div>
          </td>

          {/* <td className='td4' >
                        <div className="custom-text1-primary-medium">
                            {values.support_ticket_messages_by_reportissueidfk
                                && values.support_ticket_messages_by_reportissueidfk.length > 0 ? (
                                values.support_ticket_messages_by_reportissueidfk[0].subject
                            ) : (
                                ''
                            )}
                        </div>
                        <div className="custom-text2-secondary-normal d-flex">
                            {values.support_ticket_messages_by_reportissueidfk
                                && values.support_ticket_messages_by_reportissueidfk.length > 0 ? (
                                // values.support_ticket_messages_by_reportissueidfk[0].description
                                <span className="">{renderHTML(values.support_ticket_messages_by_reportissueidfk[0].description)}</span>
                            ) : (
                                ''
                            )}
                            {draft.length > 0 ? (
                                <div className="text-danger ml-2">(Draft)</div>
                            ) : ('')}
                        </div>
                    </td> */}

          <td className="td1">
            <div className="d-flex">
              {values.support_ticket_messages_by_reportissueidfk &&
              values.support_ticket_messages_by_reportissueidfk.length > 0 ? (
                <span className="">{renderHTML(lastreplieddesc)}</span>
              ) : (
                ""
              )}
              {draft.length > 0 ? (
                <div className="text-danger ml-2">(Draft)</div>
              ) : (
                ""
              )}
            </div>
            <div className="fw-bold">
              {letLastobj.repliedby !== null ? (
                <span>
                  {values.clients_by_reportedby.firtsname}{" "}
                  {values.clients_by_reportedby.lastname}
                </span>
              ) : (
                "Support Team"
              )}
            </div>
            <div>
              {letLastobj.repliedby !== null && values.status == "open" ? (
                <>
                  {
                    LocaleStrings.accountsetting_reportissue_waitingforsuperadminreply
                  }
                </>
              ) : (
                ""
              )}
            </div>
          </td>
          <td className="td3">
            <div
              className={classNames(
                values.status == "open" ? "bg-warning" : "bg-success",
                "issueopen-tag"
              )}
              style={{ fontWeight: "500" }}>
              {_.startCase(values.status)}
            </div>
          </td>
          <td className="td2">{tabledate}</td>
          <td className="td2">{lastrepliedon}</td>
          <td>
            <button
              className="btn btn-custom-table-white"
              onClick={() => this.openModal()}>
              {LocaleStrings.button_view}
            </button>
            {/* {values.status == 'open' ? (<>
                            
                            <Button
                                className="btn btn-primary ml-2"
                                onClick={() => this.handleresolveandreopen(values)}
                                loading={this.state.btnloading}
                            >
                                {LocaleStrings.button_close}
                            </Button>
                        </>
                        ) : (
                            <Button
                                className="btn btn-primary ml-2"
                                onClick={() => this.handleresolveandreopen(values)}
                                loading={this.state.btnloading}
                            >
                                  {LocaleStrings.accountsetting_reportissue_reopen}
                            </Button>
                        )} */}
          </td>
        </tr>
        {this.state.isOpen ? (
          <ReportIssueModal
            isOpen={this.state.isOpen}
            onClose={this.closeModal}
            data={values}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    user: state.user,
  };
};

export default connect(mapStateToProps, {
  fetchadminissueTokenClose,
  updateissueStatus,
  fetchadminissueTokenOpen,
  showError,
  showSuccess,
})(ReportIssueitemList);
